import { api } from "./common";
import { ModelFunction_Role, Id } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id } & Pick<
  ModelFunction_Role,
  "modelFunctionId" | "roleId"
>;

export const linkModelFunctionToRole = async (props: Props) => {
  await api("v2/modelfunctions/roles", {
    method: "POST",
    body: JSON.stringify({
      modelFunctionId: props.modelFunctionId,
      roleId: props.roleId,
    }),
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { modelFunctions_roles } = await fetchOrgEntities(props.subscriptionId);

  return { modelFunctions_roles };
};
